import { Badge } from '@material-ui/core';
import images from 'assets/images';
import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { Link, useLocation } from 'react-router-dom';
import { Routing } from 'shared/constants/routing';
import { useSelector } from 'react-redux';
import { IApplicationState } from './../store/state/app-state';
import { IHeaderMenu } from 'shared/constants/patient-menu-data';
import { BRAND_TITLE } from 'shared/constants/constants';

const Sidebar: React.FC = () => {
    const location = useLocation();
    const userData = useSelector((state: IApplicationState) => state.UserData);

    const [activeMenu, setActiveMenu] = React.useState(false);
    const [menuData, setMenuData] = React.useState<Array<IHeaderMenu>>([]);

    React.useEffect(() => {
        setMenuData(userData?.menuDetails);
    }, [userData?.menuDetails]);

    const toggleMenuClose = () => {
        const win_w = window.innerWidth;
        if (win_w < 1024) {
            document.body.classList.remove('show-menu');
            document.querySelector('.hamburger').classList.remove('is-active');
        }
    };

    return (
        <nav className="main-navigation">
            <Link to={Routing.TimeLine} title={BRAND_TITLE} className="logo">
                <img src={images.Logo} alt="Logo" />
            </Link>
            <ul className="sidemenu" onClick={toggleMenuClose}>
                <Scrollbars className="custom-scroll">
                    {menuData?.map((menu, i) => (
                        <li key={i}>
                            <Link
                                to={menu.route ? menu.route : '#'}
                                className={`${
                                    location?.pathname.toLowerCase().includes(menu.route) ? 'active' : ''
                                } sidemenu-link`}
                                onClick={() => setActiveMenu(!activeMenu)}
                                title={menu.label}
                            >
                                <em>
                                    <img src={menu.image} alt={menu.label} />
                                </em>
                                <span>{menu.label}</span>
                                <Badge badgeContent={menu.notifications} className="menu-badge" />
                            </Link>
                        </li>
                    ))}
                    <br />
                </Scrollbars>
            </ul>
        </nav>
    );
};

export default Sidebar;
